export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "OUR STORY",
    desc: "Our website was founded by a group of 5 passionate individuals who wanted to make a positive impact on education in rural areas. We saw the challenges that rural schools face and recognized the potential of technology to connect people and facilitate learning. Since our launch, we have been committed to bridging the education gap in rural communities by connecting volunteering teachers with these schools.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "OUR MOTTO",
    desc: "\"Education for All\" - We believe that education is a fundamental right that should be accessible to every child, regardless of their location or socioeconomic background.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "OUR MISSION",
    desc: "Our mission is to empower rural education through volunteerism by connecting passionate educators with schools in remote and underserved areas. We believe that every child deserves access to quality education, regardless of their geographical location. By leveraging the power of technology and human connection, we aim to bridge the gap between teachers and students in rural communities. Our goal is to create a community of educators who are committed to making a positive impact in the lives of children and youth, and to create a more equitable and just Tanzania through education." ,
  },
]
export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "3,000",
    title: "SUCCESS STORIES",
  },

  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "320",
    title: "TRUSTED TUTORS",
  },
  {
    cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "1,000",
    title: "SCHEDULES",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "587",
    title: "RESOURCES",
  },
]
export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/download1.jpeg",
    coursesName: "PHYSICS",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "Access to a vast array of educational materials designed to cater to students in Form 1 to 6. If you are looking to revise physics concepts our platform has got you covered.",
      },
    ],
    priceAll: "",
    pricePer: "",
  },
  {
    id: 2,
    cover: "../images/courses/images2-fotor-bg-remover-20230428105142.png",
    coursesName: "MATHEMATICS",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "With our extensive collection of mathematics educational resources, you'll have all the tools you need to succeed.",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 3,
    cover: "../images/courses/download3-fotor-bg-remover-20230428111231.png",
    coursesName: "CHEMISTRY",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "In this portion you'll have access to a plethora of educational materials in chemistry catered to students in Form 1 to 6.",
      },
    ],
    priceAll: "$50 All Course",
    pricePer: "$5 per month",
  },
  {
    id: 4,
    cover: "../images/courses/download4-fotor-bg-remover-20230428111559.png",
    coursesName: "BIOLOGY",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "In this segment you'll have an extensive range of biology educational resources at your fingertips that cater to the needs of students in Form 1 to 6.",
      },
    ],
    priceAll: "$30 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 5,
    cover: "../images/courses/download5-fotor-bg-remover-20230428112720.png",
    coursesName: "KISWAHILI",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "Here, you'll be able to access a diverse range of kiswhili educational resources that suit the needs of students in Form 1 to 6 through our platform.",
      },
    ],
    priceAll: "$300 All Course",
    pricePer: "$30 per month",
  },
  {
    id: 6,
    cover: "../images/courses/download5-fotor-bg-remover-20230428113450.png",
    coursesName: "ENGLISH",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "This area provides a broad spectrum of English educational materials designed to accommodate students from Form 1 to 6.",
      },
    ],
    priceAll: "$500 All Course",
    pricePer: "$80 per month",
  },
  {
    id: 7,
    cover: "../images/courses/download6-fotor-bg-remover-2023042811462.png",
    coursesName: "HISTORY",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "This section provides a comprehensive range of history educational resources for students in Form 1 to 6.",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$2 per month",
  },
  {
    id: 8,
    cover: "../images/courses/images6-fotor-bg-remover-20230428115538.png",
    coursesName: "CIVICS",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "This piece in our platform has an impressive collection civics of educational resources for students in Form 1 to 6.",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$40 per month",
  },
  {
    id: 9,
    cover: "../images/courses/download9-fotor-bg-remover-2023042812540.png",
    coursesName: "GEOGRAPHY",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "This section provides a comprehensive range of geography educational resources for students in Form 1 to 6.",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 10,
    cover: "../images/courses/download-fotor-bg-remover-20230428121127.png",
    coursesName: "ICT",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "If you're looking for ICT educational materials for students in Form 1 to 6, well this is the right place to be.",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 11,
    cover: "../images/courses/images12-fotor-bg-remover-20230428122044.png",
    coursesName: "BOOKKEEPING",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png",
        name: "by VolunteerEd",
        totalTime: "Here, you'll be able to access a diverse range of Bookkeeping educational resources that suit the needs of students in Form 1 to 4 through our platform",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 12,
    cover: "../images/courses/images13-fotor-bg-remover-20230428122352.png",
    coursesName: "COMMERCE",
    courTeacher: [
      {
        dcover: "../images/courses/download15.png ",
        name: "by VolunteerEd",
        totalTime: "We haven't left out our students with needs in commerce, in this segment you'll have an extensive range of commerce educational resources at your fingertips that cater to the needs of students in Form 1 to 4. ",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
]
export const online = [
  
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Art & Design Lessons",
    course: "25 Resources",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "kiswahili Lessons",
    course: "10 Resources",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "History Lessons",
    course: "15 Resources",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Geography Lessons",
    course: "15 Resources",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Math Lessons",
    course: "14 Resources",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Vocational Studies",
    course: "10 Resources",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "English Lessons",
    course: "30 Resources",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Civics Lessons",
    course: "10 Resources",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Music Lessons",
    course: "12 Resources",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Physics Lessons",
    course: "17 Resources",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Chemistry Lessons",
    course: "17 Resources",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Biology Lessons",
    course: "10 Resources",
  },  

]

export const price = [
  {
    name: "BASIC PLAN",
    price: "49K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "BEGINNER PLAN",
    price: "79K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "PREMIUM PLAN",
    price: "109k",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "ULTIMATE PLAN",
    price: "149K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
]
export const faq = [
  {
    title: "Who can volunteer to teach on your platform?",
    desc: "Anyone who is passionate about education and has the necessary skills and qualifications can volunteer to teach on our platform.",
  },
  {
    title: "Do I need to have teaching experience to volunteer?",
    desc: "Although teaching experience can be advantageous, it is not a mandatory requirement for becoming a volunteering teacher on our platform. We value passion and believe that individuals with the necessary skills and qualifications can make a meaningful impact on the education of children in rural areas.",
  },
  {
    title: "How can I become a volunteering teacher?",
    desc: "You can sign up to become a volunteering teacher on our website. After completing the registration process, you will be matched with a rural school that suits your skills and qualifications.",
  },
  {
    title: "Can I choose which school I want to volunteer for?",
    desc: "You can express your preference, but we cannot guarantee that you will be matched with your preferred school. We strive to match volunteering teachers with schools based on their skills and qualifications, as well as the needs of the school.",
  },
  {
    title: "How do you ensure the safety of students and volunteering teachers?",
    desc: "We conduct background checks on all volunteering teachers and have a strict code of conduct that they must adhere to. We also work closely with rural schools to ensure the safety of students and volunteering teachers.",
  },
  {
    title: "How can I donate or support your cause?",
    desc: "You can make a donation on our website or contact us to learn more about other ways you can support our cause. Your support can help us provide quality education to more children in rural areas.",
  },
]
export const blog = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2021",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "admin",
    date: "API. 25, 2022",
    com: "5 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela",
    cover: "../images/blog/b2.webp",
  },
  {
    id: 3,
    type: "user",
    date: "MAY. 15, 2022",
    com: "10 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela",
    cover: "../images/blog/b3.webp",
  },
  {
    id: 4,
    type: "admin",
    date: "JAN. 02, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela",
    cover: "../images/blog/b4.webp",
  },
  {
    id: 5,
    type: "admin",
    date: "DEC. 14, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela.",
    cover: "../images/blog/b5.webp",
  },
  {
    id: 6,
    type: "user",
    date: "JAN. 18, 2021",
    com: "12 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "\"Education is the most powerful weapon you can use to change the world.\" - Nelson Mandela",
    cover: "../images/blog/b6.webp",
  },
]
export const testimonal = [
  {
    id: 1,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t1.webp",
  },
  {
    id: 2,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t2.webp",
  },
  {
    id: 3,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t3.webp",
  },
]
